import { Button, Grid, GridColumn } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import AnalyticsService from '../../../services/AnalyticsService';
import { IPaymentHistoryStore } from '../../../stores/PaymentHistoryStore';
import { ITranslateStore } from '../../../stores/TranslateStore';
import FilterDateField from '../FilterDateField';

interface ITransactionFilterProps {
  paymentHistoryStore?: IPaymentHistoryStore;
  translateStore?: ITranslateStore;
  analyticsService?: AnalyticsService;
}

@inject('paymentHistoryStore', 'translateStore', 'analyticsService')
@observer
export default class TransactionFilter extends React.Component<ITransactionFilterProps> {
  public render(): JSX.Element {
    const translate = this.props.translateStore.translate;
    const store = this.props.paymentHistoryStore;
    const analyticsService = this.props.analyticsService;

    return (
      <Grid align={['bottom-xs']}>
        <GridColumn width={['sm']}>
          <FilterDateField
            id="payment-history-filter-from-date"
            label={translate('payment-history.filter.from')}
            date={store.filterFromDate}
            onChange={store.onFilterFromDateChange}
            disableDaySelection={true}
          />
        </GridColumn>
        <GridColumn width={['sm']}>
          <FilterDateField
            id="payment-history-filter-to-date"
            label={translate('payment-history.filter.to')}
            date={store.filterToDate}
            onChange={store.onFilterToDateChange}
            disableDaySelection={true}
          />
        </GridColumn>
        <GridColumn width={['sm']}>
          <Button
            text={translate('payment-history.filter.apply')}
            iconRight="#arrow-right"
            onClick={() => {
              store.loadTransactions();
              analyticsService.paymentHistoryApplyFilter(store.filterFromDate, store.filterToDate);
            }}
          />
        </GridColumn>
      </Grid>
    );
  }
}
